import { Component } from '@angular/core';
import {Vector3} from "three";
import {Store} from "@ngrx/store";
import {ActivatedRoute, EventType, Router} from "@angular/router";
import {InputService} from "../../binst/inputs/services/input.service";
import {selectCameraTarget, selectCameraZoomTarget} from "../../state/camera/camera.selector";
import {cameraActions} from "../../state/camera/camera.actions";
import * as AuthSelectors from "../../state/auth/auth.selector";
import * as ChatSelectors from "../../state/chats/chat.selector";
import {selectConnected, selectNotResponsive, selectSlow} from "../../state/network/network.selector";
import {Icon} from "@mdefy/ngx-markdown-editor";
import {IconsService} from "../../services/icons.service";
import {faIcons} from "@fortawesome/free-solid-svg-icons/faIcons";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {NgForOf} from "@angular/common";
import {FormsModule} from "@angular/forms";

@Component({
  selector: 'toolbar-location',
  standalone: true,
  imports: [
    FaIconComponent,
    NgForOf,
    FormsModule
  ],
  templateUrl: './toolbar-location.component.html',
  styleUrl: './toolbar-location.component.scss'
})
export class ToolbarLocationComponent {

  cameraTarget: Vector3

  coordX: string
  coordY: string
  coordXList: string[]
  coordYList: string[]
  zoomDisplay: string
  zoomTarget: number

  zoomLevels = [300, 500, 1200, 3000, 7000, 50000]

  leftPaneActive: boolean = false;
  rightPaneActive: boolean = false;
  unreadMessageCount = 0
  unreadMessageCountSubscription = null

  networkConnected: boolean
  networkSlow: boolean
  networkNotResponsive: boolean


  constructor(
      private store: Store,
      private router: Router,
      private route: ActivatedRoute,
      private inputService: InputService,
      public iconsService: IconsService
  ) {
    this.store.select(selectCameraTarget).subscribe((target) => {
      this.coordX = Math.round(target.x) + ""
      this.coordXList = this.coordX.split('')
      this.coordY = Math.round(target.y) + ""
      this.coordYList = this.coordY.split('')
      this.coordXList = [
        ...Array(4 - this.coordXList.length).fill(''),
        ...this.coordXList
      ]
      this.coordYList = [
        ...this.coordYList,
        ...Array(4 - this.coordYList.length).fill(''),
      ]
    })
    this.store.select(selectCameraZoomTarget).subscribe((target) => {
      this.zoomDisplay = 50 - Math.round(Math.sqrt(target)/5) + ""
      // this.zoomDisplay = Math.round(target) + ""
      this.zoomTarget = target
    })
    this.router.events.subscribe((event) => {
      this.checkIfPanesActive()
      if (event.type === EventType.NavigationEnd) {
        this.store.dispatch(
            cameraActions.triggeredCanvasResizeAnimation({ durationMs: 500 }),
        );
      }
    })
    this.store.select(AuthSelectors.selectUser).subscribe((user) => {
      if (!user) return;
      if (this.unreadMessageCountSubscription) this.unreadMessageCountSubscription.unsubscribe();
      this.unreadMessageCountSubscription = this.store.select(
          ChatSelectors.selectTotalUnreadMessagesForUser(user.id)
      ).subscribe((count) => {
        this.unreadMessageCount = count
      })
    })
    this.store.select(selectConnected).subscribe((connected) => {
      if (connected === null) return;
      this.networkConnected = connected
    })
    this.store.select(selectSlow).subscribe((isSlow) => {
      if (isSlow === null) return;
      this.networkSlow = isSlow
    })
    this.store.select(selectNotResponsive).subscribe((isNoResponse) => {
      if (isNoResponse === null) return;
      this.networkNotResponsive = isNoResponse
    })
  }

  set zoomSlider(value: number) {
    this.zoomSliderChanged(value)
  }

  get zoomSlider(): string {
    return this.zoomDisplay
  }

  zoomSliderChanged(value) {
    console.log(value)
    // this.zoomDisplay = Math.round(Math.sqrt(target)/5) + ""
    const modified = Math.pow((50 - value) * 5, 2)
    console.log("Modified to:", modified)
    this.store.dispatch(cameraActions.zoomJumped({
      absoluteZoom: modified,
      jumpTimeMs: 100
    }))
  }


  checkIfPanesActive() {
    const leftPaneRoute = this.route.children.find(
        child => child.outlet === 'left-pane'
    );
    const rightPaneRoute = this.route.children.find(
        child => child.outlet === 'right-pane'
    );
    this.leftPaneActive = !!leftPaneRoute
    this.rightPaneActive = !!rightPaneRoute
  }


  openChats() {
    if (!this.leftPaneActive) {
      this.router.navigate([{outlets: {'left-pane': "chat-bar"}}])
    } else {
      this.router.navigate([{outlets: {'left-pane': null}}])
    }
  }

  rewind() {
    this.store.dispatch(cameraActions.rewindTarget())
  }

  zoomOut() {
    this.store.dispatch(cameraActions.zoomJumped({
      absoluteZoom: 7000
    }))
  }

  changeZoom() {
    let nextZoomLevel = 0
    for (let i = 0; i < this.zoomLevels.length; i++) {
      if (this.zoomLevels[i] > this.zoomTarget - 1) {
        break
      }
      nextZoomLevel = this.zoomLevels[i]
    }
    if (this.zoomTarget > (this.zoomLevels[0] - 1) && this.zoomTarget < (this.zoomLevels[0] + 1)) {
      nextZoomLevel = this.zoomLevels[this.zoomLevels.length - 1]
    }
    this.store.dispatch(cameraActions.zoomJumped({
      absoluteZoom: nextZoomLevel, jumpTimeMs: 300
    }))
  }
}
